




































































import {Vue, Component} from "vue-property-decorator";

import ButtonSuccessful from "@/components/Atoms/ButtonSuccessful/ButtonSuccessful.vue";
import ButtonOutlineSuccessful from "@/components/Atoms/ButtonOutlineSuccessful/ButtonOutlineSuccessful.vue";
import CheckBox from "@/components/Atoms/CheckBox/CheckBox.vue";
import TextInputGroup from "@/components/Molecules/TextInputGroup/TextInputGroup.vue";
import TextInput from "@/components/Atoms/TextInput/TextInput.vue";
import DeleteModal from "@/components/Atoms/DeleteModal/DeleteModal.vue";
import BackButton from "@/components/Atoms/BackButton/BackButton.vue";
import CheckInputQuestion from "@/components/Atoms/CheckInputQuestion/CheckInputQuestion.vue";
import {CHECKBOX_STATUS} from "@/constants";

@Component({
  components: {
    ButtonSuccessful,
    ButtonOutlineSuccessful,
    CheckBox,
    TextInputGroup,
    TextInput,
    BackButton,
    CheckInputQuestion,
    DeleteModal
  }
})
export default class AtomPage extends Vue {
  private checkboxStatus = CHECKBOX_STATUS

  // Button emit action
  public onClickToButton(): void {
    console.log('onClickToButton')
  }

  public onCheckboxChange(value: string | number): void {
    console.log('value', value)
  }
}
